import { ethGetAbiFunctions, ethGetTxStatus, ethNftCreateCollection, ethNftGetAbi, ethNftMint, ethNftVerify, ethTokenCreate, ethTokenSmartContractInteraction, ethTokenTransfer, ethTokenVerify } from "./axiosRequests/axiosHandlerEth";
import { Chain } from "./Chain";
import { EthNftSmartContractVerify, TokenSmartContractInteraction } from "./models";
import { EthNftCreateCollection } from "./models/modelsEthNft/EthNftCreateCollection";
import { EthNftMint } from "./models/modelsEthNft/EthNftMint";
import { EthGetAbi } from "./models/modelsEthSmartContract/getAbi";
import { EthGetAbiFunctions } from "./models/modelsEthSmartContract/getAbiFunctions";
import { EthGetTxStatus } from "./models/modelsEthSmartContract/getStatus";
import { EthTokenCreate } from "./models/modelsEthToken/EthTokenCreate";
import { EthTokenSmartContractVerify } from "./models/modelsEthToken/EthTokenSmartContractVerify";
import { EthTransfer } from "./models/modelsEthToken/EthTransfer";

export class Ethereum extends Chain { 
    public ethCreateToken = async (
        payload: EthTokenCreate
    ): Promise<any> => {
        return await ethTokenCreate(payload, this.initialize);
    }

    public ethTransferToken = async (
        payload: EthTransfer
    ): Promise<any> => {
        return await ethTokenTransfer(payload, this.initialize);
    }

    public ethVerifyToken = async (
        payload: EthTokenSmartContractVerify
    ): Promise<any> => {
        return await ethTokenVerify(payload, this.initialize);
    }

    public ethVerifyNft = async (
        payload: EthNftSmartContractVerify
    ): Promise<any> => {
        return await ethNftVerify(payload, this.initialize);
    }

    public ethNftCreate = async (
        payload: EthNftCreateCollection
    ): Promise<any> => {
        return await ethNftCreateCollection(payload, this.initialize);
    }


    public ethMintNft = async (
        payload: EthNftMint
    ): Promise<any> => {
        return await ethNftMint(payload, this.initialize);
    }
     
    public ethNftAbiFunctions = async (
        payload: EthGetAbiFunctions
    ): Promise<any> => {
        return await ethGetAbiFunctions(payload, this.initialize);
    }

    public ethNftAbi = async (
        payload: EthGetAbi
    ): Promise<any> => {
        return await ethNftGetAbi(payload, this.initialize);
    }

    public ethTxStatus = async (
        payload: EthGetTxStatus
    ): Promise<any> => {
        return await ethGetTxStatus(payload, this.initialize);
    }

    // public establishConnection = async (networkProvider: any): Promise<any> => {
    //     // "https://data-seed-prebsc-1-s1.binance.org:8545"
    //     return new Web3(new Web3.providers.HttpProvider(networkProvider))
    // }

    // public signTransaction = async (
    //     rawTransaction: any,
    //     web3: any,
    //     privateKey: any
    // ): Promise<any> => {
    //     const decryptedAccount = web3.eth.accounts.privateKeyToAccount(
    //         privateKey
    //     )
    //     return await decryptedAccount.signTransaction(rawTransaction)
    // }

    // public sendTransaction = async (signedTx: any, web3: any): Promise<any> => {
    //     await web3.eth
    //         .sendSignedTransaction(signedTx.rawTransaction)
    //         .then((receipt: any) =>
    //             console.log('Transaction receipt: ', receipt)
    //         )
    // }

    public ethTokenContractInteract = async (payload: TokenSmartContractInteraction): Promise<any> => {
        return await ethTokenSmartContractInteraction(payload, this.initialize);
     }
}